module.exports = __webpack_public_path__ + "static/media/PreRegistrationDesktop.8f12fa78.png";